/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Filter_VarianceInputs */

const vi_stocktake_filter_variance = /** @type {(inputs: Stocktake_Filter_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có lệch`)
};

/**

* @param {Stocktake_Filter_VarianceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_filter_variance = /** @type {((inputs?: Stocktake_Filter_VarianceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Filter_VarianceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_filter_variance(inputs)
});